import { queryFetch } from '../api';
import { useMutation } from '@tanstack/react-query';
import { ExternalScheduleReq, ExternalScheduleResp } from './types';
import { useJobRefetch } from '@hooks/job/refetch';

export const useUpdateExternalSchedule = ({
  callback,
}: {
  callback: (data: ExternalScheduleResp) => void;
}) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'external', action: 'update' } });

  const { mutate, isPending } = useMutation({
    mutationFn: ({
      jobId,
      scheduleId,
      ...data
    }: ExternalScheduleReq): Promise<ExternalScheduleResp> =>
      queryFetch({
        url: `jobs/${jobId}/external_schedules/${scheduleId}/reschedule`,
        data,
        opt: { method: 'POST' },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      callback(data as ExternalScheduleResp);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
